import PropTypes from 'prop-types';
import { useState } from 'react';
import { useRouter } from 'next/router';
// @mui
import { List, Collapse } from '@mui/material';
//
import { NavItemRoot, NavItemSub } from './NavItem';
import { getActive } from '..';

// ----------------------------------------------------------------------

NavListRoot.propTypes = {
  isCollapse: PropTypes.bool,
  isSideMenu: PropTypes.bool,
  list: PropTypes.object,
};

export function NavListRoot({ list, isCollapse, isSideMenu }) {
  const { pathname, asPath } = useRouter();

  const active = getActive(list?.path, pathname, asPath);

  const [open, setOpen] = useState(active);

  const hasChildren = list?.children;

  if (hasChildren) {
    return (
      <>
        <NavItemRoot item={list} isCollapse={isCollapse} isSideMenu={isSideMenu} active={active} open={open} onOpen={() => setOpen(!open)} />

        {!isCollapse && (
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {(list.children || []).map((item, i) => (
                <NavListSub isSideMenu={isSideMenu} isCollapse={isCollapse} key={i} list={item} />
              ))}
            </List>
          </Collapse>
        )}
      </>
    );
  }

  return <NavItemRoot item={list} active={active} isCollapse={isCollapse} isSideMenu={isSideMenu} />;
}

// ----------------------------------------------------------------------

NavListSub.propTypes = {
  list: PropTypes.object,
  isSideMenu: PropTypes.bool,
};

function NavListSub({ list, isSideMenu }) {
  const { pathname, asPath } = useRouter();

  const active = getActive(list.path, pathname, asPath);

  const [open, setOpen] = useState(active);

  const hasChildren = list.children;

  if (hasChildren) {
    return (
      <>
        <NavItemSub isSideMenu={isSideMenu} item={list} onOpen={() => setOpen(!open)} open={open} active={active} />

        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={{ pl: 3 }}>
            {(list.children || []).map((item, index) => (
              <NavItemSub isSideMenu={isSideMenu} key={index} item={item} active={getActive(item.path, pathname, asPath)} />
            ))}
          </List>
        </Collapse>
      </>
    );
  }

  return <NavItemSub isSideMenu={isSideMenu} item={list} active={active} />;
}
